export default __webpack_public_path__ + "static/media/cover_page-01_720.a3592980.png";